module.exports = __webpack_public_path__ + "img/magnifying-glass-blue.40e7b738.svg";